// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k7hj","newExpiryDate":"styles_newExpiryDate__6b27d","footer":"styles_footer__2ihgE"};